import { render, staticRenderFns } from "./Jeopardy.vue?vue&type=template&id=64e24fde&"
import script from "./Jeopardy.vue?vue&type=script&lang=js&"
export * from "./Jeopardy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports